export const STATUS_ROMANEIO = {
  rascunho: { label: "Rascunho", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  separado: { label: "Separado", cls: "bg-blue-50 text-blue-700 border-blue-300" },
  em_transito: { label: "Em trânsito", cls: "bg-amber-50 text-amber-700 border-amber-300" },
  entregue: { label: "Entregue", cls: "bg-emerald-50 text-emerald-700 border-emerald-300" },
  entregue_divergencia: { label: "Entregue c/ divergência", cls: "bg-orange-50 text-orange-700 border-orange-300" },
  nao_confirmado: { label: "Não confirmado", cls: "bg-red-50 text-red-700 border-red-300" },
  fechado: { label: "Fechado", cls: "bg-luvcorp-navy text-white border-luvcorp-navy" },
  cancelado: { label: "Cancelado", cls: "bg-slate-200 text-slate-500 border-slate-300 line-through" },
};

export const fmtDataBR = (s) => {
  if (!s) return "—";
  try { return new Date(String(s).slice(0, 10) + "T00:00:00").toLocaleDateString("pt-BR"); } catch { return s; }
};

export const fmtHora = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }); } catch { return ""; }
};

export const linkConferencia = (id) => `${window.location.origin}/conferencia-romaneio/${id}`;
